import { render, staticRenderFns } from "./ExpressionEdit.vue?vue&type=template&id=40bc55fd&scoped=true&"
import script from "./ExpressionEdit.vue?vue&type=script&lang=ts&"
export * from "./ExpressionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ExpressionEdit.vue?vue&type=style&index=0&id=40bc55fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc55fd",
  null
  
)

export default component.exports